import { useState } from 'react'
import Modal from 'react-bootstrap/Modal'
import { useSelector } from 'react-redux'
import { RootState } from 'store/redux'
import useSetAddFirstBox from './hooks/useSetAddFirstBox'
import useIsTrancparency from './hooks/useIsTrancparency'
import useSetCustomImage from './hooks/useSetCustomImage'
import { useNavigate } from 'react-router-dom'
import DotsWhiteLoading from 'components/loadings/dotsWhiteLoading'

interface IModalProps {
    show: boolean
    onHide: () => void
}
const LastAddBoxModal = ({ show, onHide }: IModalProps) => {
    const store = useSelector((state: RootState) => state.MoneyPoolBoxAdd)
    const [statege, setStage] = useState<number | undefined>()
    const { CustomImageMutate, isLoadingImage } = useSetCustomImage(statege)
    const { mutate, isLoading } = useSetAddFirstBox(CustomImageMutate, statege)
    const { handlePayload } = useIsTrancparency()
    const handleFirst = () => {
        const payload = handlePayload()
        mutate(payload)
    }
    const navigate = useNavigate()

    return (
        <Modal
            show={show}
            onHide={onHide}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <div className=" p-2">
                <p className="text-[#706F6F] text-center px-10 mt-3 text-sm">
                    قبل از ایجاد صندوق پس انداز {store.name} یکی از گزینه های
                    زیر را انتخاب کنید:
                </p>
                <hr className=" my-2" />
                <div className="mb-[0.125rem] flex ps-[1.5rem] my-3 items-center text-sm">
                    <input
                        className="relative -ms-[1.5rem] me-1 mt-0.5  rounded-full border-2 border-solid border-secondary-500 before:pointer-events-none before:absolute before:h-4 before:w-4 before:scale-0 before:rounded-full before:bg-transparent before:opacity-0 before:shadow-checkbox before:shadow-transparent before:content-[''] after:absolute after:z-[1] after:block after:h-4 after:w-4 after:rounded-full after:content-[''] checked:border-green-1 checked:before:opacity-[0.16] checked:after:absolute checked:after:left-1/2 checked:after:top-1/2 checked:after:h-[0.625rem] checked:after:w-[0.625rem] checked:after:rounded-full checked:after:border-green-1 checked:after:bg-green-1 checked:after:content-[''] checked:after:[transform:translate(-50%,-50%)] hover:cursor-pointer hover:before:opacity-[0.04] hover:before:shadow-black/60 focus:shadow-none focus:outline-none focus:ring-0 focus:before:scale-100 focus:before:opacity-[0.12] focus:before:shadow-black/60 focus:before:transition-[box-shadow_0.2s,transform_0.2s] checked:focus:border-green-1 checked:focus:before:scale-100 checked:focus:before:shadow-checkbox checked:focus:before:transition-[box-shadow_0.2s,transform_0.2s] rtl:float-right dark:border-neutral-400 dark:checked:border-green-1"
                        type="radio"
                        name="flexRadioDefault"
                        id="radioDefault01"
                        onChange={() => setStage(0)}
                        checked={statege === 0}
                    />
                    <label
                        className="mt-px  ps-[0.15rem] hover:cursor-pointer text-xs"
                        htmlFor="radioDefault01"
                    >
                        خارج از همیان به عنوان مدیر صندوق {store?.name} پس انداز
                        و پرداخت در این صندوق دارم.
                    </label>
                </div>
                <hr className=" my-2" />
                <div className="mb-[0.125rem] flex ps-[1.5rem] my-3 items-center">
                    <input
                        className="relative -ms-[1.5rem] me-1 mt-0.5 rounded-full border-2 border-solid border-secondary-500 before:pointer-events-none before:absolute before:h-4 before:w-4 before:scale-0 before:rounded-full before:bg-transparent before:opacity-0 before:shadow-checkbox before:shadow-transparent before:content-[''] after:absolute after:z-[1] after:block after:h-4 after:w-4 after:rounded-full after:content-[''] checked:border-green-1 checked:before:opacity-[0.16] checked:after:absolute checked:after:left-1/2 checked:after:top-1/2 checked:after:h-[0.625rem] checked:after:w-[0.625rem] checked:after:rounded-full checked:after:border-green-1 checked:after:bg-green-1 checked:after:content-[''] checked:after:[transform:translate(-50%,-50%)] hover:cursor-pointer hover:before:opacity-[0.04] hover:before:shadow-black/60 focus:shadow-none focus:outline-none focus:ring-0 focus:before:scale-100 focus:before:opacity-[0.12] focus:before:shadow-black/60 focus:before:transition-[box-shadow_0.2s,transform_0.2s] checked:focus:border-green-1 checked:focus:before:scale-100 checked:focus:before:shadow-checkbox checked:focus:before:transition-[box-shadow_0.2s,transform_0.2s] rtl:float-right dark:border-neutral-400 dark:checked:border-green-1"
                        type="radio"
                        name="flexRadioDefault"
                        id="radioDefault02"
                        checked={statege === 1}
                        onChange={() => setStage(1)}
                    />
                    <label
                        className="mt-px  ps-[0.15rem] hover:cursor-pointer text-xs"
                        htmlFor="radioDefault02"
                    >
                        هنوز هیچ گونه پرداختی در صندوق {store?.name} ثبت نشده
                        است
                    </label>
                </div>
                {statege === 0 && (
                    <div className=" px-2 ">
                        <hr className=" my-2" />
                        <button
                            className=" w-full text-white bg-green-1 rounded-lg py-2.5 my-2"
                            onClick={() => {
                                handleFirst()
                            }}
                            disabled={isLoading}
                        >
                            {isLoading ? (
                                <DotsWhiteLoading />
                            ) : (
                                'ثبت سوابق مدیر'
                            )}
                        </button>
                    </div>
                )}
                {statege === 1 && (
                    <div className=" px-2 ">
                        <hr className=" my-2" />
                        <button
                            className=" w-full text-white bg-green-1 rounded-lg py-2.5 my-2"
                            onClick={handleFirst}
                            disabled={isLoading}
                        >
                            {isLoading ? <DotsWhiteLoading /> : 'ایجاد صندوق'}
                        </button>
                    </div>
                )}
            </div>
        </Modal>
    )
}

export default LastAddBoxModal
